function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M0 0h30v30H0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  fill: "#797D94",
  d: "M6.107 8.554L15 14.779l8.893-6.225A1.006 1.006 0 0 0 23 8H7c-.388 0-.728.227-.893.554zM6 10.92V21c0 .548.452 1 1 1h16c.548 0 1-.452 1-1V10.92l-8.427 5.9a1 1 0 0 1-1.146 0L6 10.92zm20-1.938V21c0 1.652-1.348 3-3 3H7c-1.652 0-3-1.348-3-3V8.982A3.006 3.006 0 0 1 7 6h16a3.006 3.006 0 0 1 3 2.983z",
  mask: "url(#b)"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30"
  }, props), _ref, _ref2);
};

export default SvgComponent;